
const AD_CLIENT_ID = process.env.REACT_APP_AD_CLIENT_ID || '';
const AD_TENANT_ID = process.env.REACT_APP_AD_TENANT_ID || '';
const AD_REDIRECT_URL = process.env.REACT_APP_AD_REDIRECT_URL || '';

export const msalConfig = {
    auth: {
        clientId: AD_CLIENT_ID,
        authority:`https://login.microsoftonline.com/${AD_TENANT_ID}`,
        redirectUri: AD_REDIRECT_URL,
    },
    cache: {
        cacheLocation: "localStorage", // or "localStorage"
        storeAuthStateInCookie: true
    },
    login: {
        navigateToLoginRequestUrl: false
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};
